// removed by extract-text-webpack-plugin
module.exports = {"projectShare":"_12fgWb7mQndANPg5","title":"_3YjXC_nhu2mzRq0T","label":"BaAxfOoCPEjSKOgg","link":"iURPAs9jEqSofz9G","input":"_21BJAR1Jb0OPgnKV","social":"_3FED4-eosSEHnyZK","buttons":"_21SUYuOgFCLcY_MP","caption":"n86Qx9i0ZK_azHWi"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/ProjectShare/ProjectShare.pcss
// module id = 495
// module chunks = 1